import 'viewerjs/dist/viewer.css'

import Viewer from 'v-viewer'
import Vue from 'vue'

Vue.use(Viewer)
